import { Box, Container } from "@mui/material";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SharedHeader from "../../../../generic-components/shared-header/SharedHeader";
import CustomerServiceFooter from "../manage-my-shared-cost-content/CustomerServiceFooter";
import CancelMySharedCostContent from "./cancel-my-shared-cost-content/CancelMySharedCostContent";
import { useEffect } from "react";
import Loader from "../../../../generic-components/loader";
import usePlan from "../../../../../hooks/usePlan";
import usePlanDetails from "../../../../../hooks/usePlanDetails";

const CancelMySharedCostAVC = ({ user }) => {
  const { plans } = usePlan();
  const { fetchCompletePlanDetails, isPlanLoading } = usePlanDetails();

  useEffect(() => {
    if (user.id && user.organisation_id) {
      fetchCompletePlanDetails(user.id, user.organisation_id);
    }
  }, [user.organisation_id, user.id]);

  return (
    <Box className="application-page-container space-from-top">
      <SharedHeader heading="My Shared Cost AVC" />
      <Container>
        {isPlanLoading ? (
          <Box className="mt-200">
            <Loader />
          </Box>
        ) : (
          <>
            <CancelMySharedCostContent plans={plans} />
            <CustomerServiceFooter />
          </>
        )}
      </Container>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state?.user?.user,
  };
};

CancelMySharedCostAVC.propTypes = {
  user: PropTypes.object,
};

export default connect(mapStateToProps)(CancelMySharedCostAVC);
